import styled from 'styled-components';

import mediaQueries from 'constants/mediaQueries';
import { imageBackgroundFallback, imageBoxShadow } from 'constants/colors';

export const Wrapper = styled.div<{ direction: string }>`
  display: flex;
  flex-direction: ${({ direction }) =>
    direction === 'right' ? 'row-reverse' : 'row'};
  justify-content: space-between;
  margin: 32px 0;

  ${mediaQueries.mobileOnly} {
    flex-direction: column;
    margin: 28px 0;
  }
`;

export const Image = styled.div<{ url: string }>`
  flex: 1;
  height: 264px;
  max-width: 432px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  margin: 0px 12px;
  ${props =>
    props.url
      ? `background-image: url(${props.url});`
      : `background-color: ${imageBackgroundFallback};`}
  ${imageBoxShadow}

  ${mediaQueries.mobileOnly} {
    height: 210px;
    max-width: 100%;
    margin: 0px;
    flex: none;
  }
`;

export const Description = styled.div`
  flex: 1;
  max-width: 432px;
  margin: 0px 12px;

  ${mediaQueries.mobileOnly} {
    max-width: 100%;
    margin: 0px;
    margin-top: 32px;
    flex: none;
  }
`;

export const TitleWrapper = styled.div`
  margin-bottom: 16px;
`;
